/**
 * Получаем дату либо строкой либо числовом timestamp
 * и приводим в строке формата Y-m-d
 * @param value timestamp or string date
 * @returns {string} (Y-m-d)
 */

/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import {
  RULE_SIMPLE_SUM,
  RULE_FIVE_SUM,
  RULE_TEN_SUM,
  RULE_FIVE_AND_TEN_SUM,
} from '@/modules/Simulators';
import { MIN_RATE, RATE_SCALE, SOUND_URL } from '../modules/ArifmetikBook';

export const toDate = value => {
  let d;
  if (typeof value === 'string') {
    d = new Date(value);
  } else {
    d = new Date(value * 1000);
  }
  const [day, month] = [d.getDate(), d.getMonth() + 1].map(num =>
    num < 10 ? num.toString().padStart(2, '0') : num
  );
  return [d.getFullYear(), month, day].join('-');
};

/*
 * Обновление массива элементов по индексу элемента в массиве
 * @param {array} exchangKeys = [{id:1, ...}, {id:2, ...}]
 * @param {object} payload = {id:2, ..., field: 'additional'}
 * @return {array} [{id:1, ...}, {id:2, ..., field: 'additional'}]
 */
export const updatingElementArray = (exchangKeys, payload) =>
  exchangKeys.map((elem, index) => {
    if (index === payload.itemIndex) {
      return { ...elem, errorMessage: payload.errorMessage };
    }
    return elem;
  });

/**
 * Просто ролучение случайного числа
 * @param {number} min
 * @param {number} max
 * @returns {*}
 */
export const getSimpleRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min)) + min;

/* eslint-disable no-bitwise */
export const uniqueId = () =>
  'xxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

/* eslint-enable no-bitwise */

export const getRemainAccessDays = a => {
  const remains = a - Date.now() / 1000;
  return remains < 0 ? 0 : Math.floor(remains / (24 * 60 * 60));
};

export const normalizeAccessDays = (
  value // формат выводит в виде целых дней
) =>
  !Number.isNaN(+value)
    ? Date.now() / 1000 + // но здесь оно преобразуется в тот вид, в котором хранится
      parseInt(value || 0, 10) * (60 * 60 * 24) + // прибавляет к текущей дате количество дней
      5 // пятерка фиксит отображение. иначе задается на день меньше
    : 0;

export const checkMode = (mode, numbers) => {
  const numSet = new Set((numbers ?? []).map(x => Number(x)));

  const rules = {
    [RULE_SIMPLE_SUM]: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    [RULE_FIVE_SUM]: ['1', '2', '3', '4'],
    [RULE_TEN_SUM]: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    [RULE_FIVE_AND_TEN_SUM]: ['6', '7', '8', '9'],
  };

  const getFilteredNumbers = key => {
    const filtered = rules[key].filter(x => numSet.has(Number(x)));
    return filtered.length ? filtered : rules[key];
  };

  return rules[mode] ? getFilteredNumbers(mode) : [];
};

export const diffNumbers = (mode, numbers) => {
  const ruleSets = {
    [RULE_FIVE_SUM]: ['1', '2', '3', '4'],
    [RULE_TEN_SUM]: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    [RULE_FIVE_AND_TEN_SUM]: ['6', '7', '8', '9'],
  };

  const numberSet = new Set(numbers.map(x => Number(x)));
  return (ruleSets[mode] || []).filter(x => !numberSet.has(Number(x)));
};

export const dinamicFontSize = (parrent, elems, initial, scale) => {
  const startElemSize = initial * scale;

  if (parrent.current) {
    const height = parseInt(parrent.current.style.maxHeight, 10);

    if (elems * startElemSize <= height) {
      return `${initial}px`;
    }

    return Math.floor(height / elems / scale);
  }

  return null;
};

export const adaptiveFontSize = (parrent, elems, scale) => {
  if (parrent.current) {
    const height = parseInt(parrent.current.clientHeight, 10);

    return Math.floor(height / elems / scale);
  }

  return 0;
};

export const getRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const customSort = (a, s, prop) =>
  a.sort((x1, x2) => {
    const i1 = s.indexOf(x1[prop]);
    const i2 = s.indexOf(x2[prop]);
    // eslint-disable-next-line no-nested-ternary
    return i1 < 0 ? 1 : i2 < 0 ? -1 : i1 - i2;
  });

export const sortContent = (a, s) =>
  a.sort((x1, x2) => {
    // const i1 = s.indexOf(x1.status);
    // const i2 = s.indexOf(x2.status);
    const i1 = s.findIndex(el => x1.startsWith(el));
    const i2 = s.findIndex(el => x2.startsWith(el));
    // eslint-disable-next-line no-nested-ternary
    return i1 < 0 ? 1 : i2 < 0 ? -1 : i1 - i2;
  });

export const getMainStatus = works => {
  let status = 'new';

  if (works?.every(hw => hw?.tasksCount?.fill.all === hw.count)) {
    if (works?.some(hw => hw?.tasksCount?.overfill.all)) {
      status = 'overfill';
      return status;
    }

    status = 'success';
    return status;
  }
  if (works?.some(hw => hw?.tasksCount?.fill.all > 0)) {
    status = 'process';
    return status;
  }

  return status;
};
// && hw.tasksCount <= hw.count
export const getWorkStatus = work => {
  let status = 'new';

  if (work.tasksCount?.overfill.all) {
    status = 'overfill';
    return status;
  }
  if (work.count === work.tasksCount?.fill.all) {
    status = 'success';
    return status;
  }
  if (work.tasksCount?.fill.all > 0 && work.tasksCount?.fill.all < work.count) {
    status = 'process';
    return status;
  }

  return status;
};

export const getFrontendDate = value =>
  value ? moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
export const getBackendDate = value =>
  value ? moment(value, 'DD.MM.YYYY').format('YYYY-MM-DD') : '';

export const getResetTime = dateObj => {
  dateObj.setHours(0);
  dateObj.setMinutes(0);
  dateObj.setSeconds(0);
  dateObj.setMilliseconds(0);
  return dateObj.getTime();
};
export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export const dataToForm = formData => {
  const data = new FormData();

  Object.entries(formData).forEach(([key, value]) => data.append(key, value));

  return data;
};

export const nameInitials = (user = {}) =>
  [user.name, user.surname, user.patronymic].join(' ');

export const toOptions = callback => options =>
  (Array.isArray(options) ? options : Object.entries(options)).map(x =>
    callback(x)
  );

export const createAudio = (text, rate = 1) => {
  const audio = new Audio(`${SOUND_URL}/${text}`);

  audio.playbackRate = Math.max(MIN_RATE, rate * RATE_SCALE);
  audio.volume = 0;
  audio.autoplay = true;

  return audio;
};

export const createQueryParams = data =>
  Object.entries(data)
    .map(([key, value], i) => `${i === 0 ? '?' : '&'}${key}=${value}`)
    .join('');

export const formatNumWithCommas = num => {
  if (num === undefined || num === null) return '0';
  // приводит целое и дробное число к формату с запятой 2000.05 => 2,000.05
  const str =
    typeof num === 'number'
      ? num.toString()
      : String(num).replace(/[^0-9.-]/g, '');
  const parts = str.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
};

// для рисовки диплома
export const normalizeCategory = (category, source = 'settings') => {
  if (!category) return {};

  if (source === 'template') {
    const { fromYear, toYear, stages, id } = category;

    return {
      id,
      years: fromYear && toYear ? [fromYear, toYear] : [],
      params: stages || [],
    };
  }

  // форматируем как в settings (старый формат)
  console.log('category', category);
  return category;
};

// формат времени для Шульте
export const formatTime = totalSeconds => {
  if (!totalSeconds && totalSeconds !== 0) {
    return '00:00';
  }
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
};
